import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ListItemComponent} from './list-item/list-item.component';
import {SectionHeaderComponent} from './section-header/section-header.component';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import {FlexLayoutModule} from '@angular/flex-layout';
import {ListWrapperComponent} from './list-wrapper/list-wrapper.component';
import {TranslateModule} from '@ngx-translate/core';
import {MessageComponent} from './message/message.component';
import {DisableControlDirective} from './disable-control/disable-control.directive';
import {DisableAllDirective} from './disable-all/disable-all.directive';
import {PasswordStrengthValidatorComponent} from './password-strength-validator/password-strength-validator.component';
import {MatLegacyProgressBarModule as MatProgressBarModule} from '@angular/material/legacy-progress-bar';
import { AvatarComponent } from './avatar/avatar.component';
import { IncidentPopupComponent } from '../popups/Incident-popup/incident-popup.component';
import {FooterComponent} from './footer/footer.component';


@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    MatListModule,
    TranslateModule,
    MatProgressBarModule
  ],
  declarations: [
    ListItemComponent,
    SectionHeaderComponent,
    ListWrapperComponent,
    MessageComponent,
    DisableControlDirective,
    DisableAllDirective,
    PasswordStrengthValidatorComponent,
    AvatarComponent,
    IncidentPopupComponent,
    FooterComponent
  ],
  exports: [
    ListItemComponent,
    SectionHeaderComponent,
    ListWrapperComponent,
    MessageComponent,
    DisableControlDirective,
    DisableAllDirective,
    PasswordStrengthValidatorComponent,
    AvatarComponent,
    IncidentPopupComponent,
    FooterComponent
  ],
})
export class LinaUiModule {
}
